<script lang="ts">
	import { timestampDate } from "@bufbuild/protobuf/wkt";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import type { Poll } from "#gen/forms/v1/poll_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
	import Countdown from "#lib/components/page/components/poll/Countdown.svelte";
	import { DEFAULT_PRE_VOTE_HEADER, DEFAULT_WINDOW_FORMAT_OPTIONS } from "#lib/components/page/components/poll/constants.js";
	import { formatTimestamp } from "#lib/timestamp.js";

	interface Props {
		poll: Poll;
		mode: Mode;
		onComplete: () => void;
	}

	const { poll, mode, onComplete }: Props = $props();
</script>

{#if poll.window?.start}
	<div class="flex w-full flex-col items-center gap-4">
		<P size="sm" class="w-full font-(--poll-countdown-header-font-weight) text-(--poll-countdown-header-text-color)" style="font-size: var(--poll-countdown-header-text-size); text-align: var(--poll-countdown-header-text-alignment);">{poll.preVoteHeader || DEFAULT_PRE_VOTE_HEADER}</P>
		<Countdown running={mode !== Mode.EDITING} targetDate={timestampDate(poll.window.start)} {onComplete} />
		<div class="flex w-full gap-1" style="text-align: var(--poll-countdown-date-text-alignment); justify-content: var(--poll-countdown-date-text-alignment);">
			<Icon iconSet="heroicons" name="calendar-days" class="h-5 w-5 text-(--poll-countdown-date-text-color)" />
			<P size="xs" class="font-(--poll-countdown-date-font-weight) text-(--poll-countdown-date-text-color)" style="font-size: var(--poll-countdown-date-text-size);">{formatTimestamp(poll.window.start, undefined, undefined, DEFAULT_WINDOW_FORMAT_OPTIONS)}</P>
		</div>
	</div>
{/if}
